import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import { Text, Box, Flex } from 'atoms';

export default function QRTimerConfirmation({
	visible,
	onClose,
	onClear,
	infoText,
	yesText = 'Clear',
	noText = 'No',
}) {
	const handleCancel = () => {
		onClose();
	};

	const handleOk = () => {
		onClear();
		handleCancel();
	};

	return (
		<Modal title={null} closable={false} footer={null} visible={visible} width={300}>
			<Text textAlign="center" fontSize="14px">
				{infoText || 'Do you want to clear the details?'}
			</Text>
			<Flex justifyContent="center" pt="1rem">
				<Box
					width="75px"
					height="32px"
					borderRadius="4px"
					border="1px solid #FD6767"
					lineHeight="32px"
					textAlign="center"
					fontSize="12px"
					cursor="pointer"
					onClick={handleCancel}
				>
					{noText}
				</Box>
				<Box
					width="75px"
					height="32px"
					ml="1rem"
					borderRadius="4px"
					bg="#FD6767"
					fontSize="12px"
					lineHeight="32px"
					textAlign="center"
					cursor="pointer"
					onClick={handleOk}
					color="white"
				>
					{yesText}
				</Box>
			</Flex>
		</Modal>
	);
}

QRTimerConfirmation.propTypes = {
	visible: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onClear: PropTypes.func.isRequired,
	infoText: PropTypes.string,
	yesText: PropTypes.string,
	noText: PropTypes.string,
};
